import { useContext } from "react"

import { AppContext } from "../../store/AppProvider"

export function Home() {
    const { activeRole, name: { displayName } } = useContext(AppContext)
    return (
        <div>
            {Boolean(activeRole) &&
                <><div className='header-title'>
                    DASHBOARD
                </div>
                    <h2>
                        Welcome Back, {displayName}
                    </h2>
                </>}

            {!Boolean(activeRole) &&
                <div style={{ marginTop: 10, color: 'red', fontSize: 20 }}>
                    You don't have access to this application.
                </div>}
        </div>
    )
}